<script setup lang="ts">
import HeaderLink from '@/components/layouts/header/HeaderLink.vue'
import { MenuButton, Menu, MenuItem, MenuItems } from '@headlessui/vue'
import { CONTACT_MAIL, getNavigationLanguageMenuItems, SocialLink } from '@/config/config.ts'
import { computed } from 'vue'
import { useTranslations } from '@/composables/useTranslations.ts'
import { useUserStore } from '@/stores/user.store.ts'
import type { UILanguage } from '@/enums.ts'
import { storeToRefs } from 'pinia'

const { t } = useTranslations()
const userStore = useUserStore()
const { localeLanguage } = storeToRefs(userStore)
const projectLanguages = computed(() => {
  return getNavigationLanguageMenuItems().filter((({ code }) => {
    return code != localeLanguage.value
  }))
})
const currentLanguageFlag = computed(() => {
  return getNavigationLanguageMenuItems().find(({ code }) => {
    return code === localeLanguage.value
  })?.imgUrl ?? '/images/flags_squared/great_britain.png'
})

function onChangeLanguage(langCode: UILanguage) {
  userStore.setLocaleLanguage(langCode)
  window.location.reload()
}

</script>

<template>
  <div
    class="left-0 flex-col max-w-full md:max-w-[732px] mr-0 md:mr-[73px] [zoom:0.8] md:[zoom:1] sm:flex-row w-full absolute bottom-full right-0 ml-0 md:ml-auto bg-[#6D4DFF] text-white rounded-t-[38px] pt-3 pb-3 sm:pt-[22px] sm:pb-[20px] pl-[55px] pr-[44px] flex items-center justify-between gap-2"
    style="box-sizing: border-box"
  >
    <HeaderLink :icon="['fas', 'envelope']" :text="CONTACT_MAIL" size="lg" />

    <HeaderLink
      :href="SocialLink.CONTACT"
      :icon="['far', 'clock']"
      :text="t('header.workSchedule')"
      size="lg"
    />

    <div class="flex items-center gap-4">
      <HeaderLink :icon="['fab', 'instagram']" :href="SocialLink.INSTAGRAM" />
      <HeaderLink :icon="['fab', 'linkedin-in']" :href="SocialLink.LINKED_IN" />
      <HeaderLink :icon="['fab', 'youtube']" :href="SocialLink.YOUTUBE" />
      <HeaderLink :icon="['fab', 'facebook-f']" :href="SocialLink.FACEBOOK" />
      <HeaderLink :icon="['fab', 'twitter']" :href="SocialLink.X" />

      <Menu as="div" class="relative">
        <MenuButton
          class="relative flex max-w-xs items-center rounded-full bg-indigo-600 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600"
        >
          <div
            class="w-8 h-8 flex items-center justify-center rounded-full overflow-hidden hover:opacity-80 transition-opacity"
          >
            <img
              :src="currentLanguageFlag"
              :alt="userStore.localeLanguage"
              class="w-8 h-8 object-cover"
            />
          </div>
        </MenuButton>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <MenuItems
            style="z-index: 100"
            class="absolute -right-5 z-10 mt-2 w-16 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none"
          >
            <MenuItem v-for="item in projectLanguages" :key="item.name" v-slot="{ active }">
              <img
                :src="item.imgUrl"
                :alt="item.code"
                @click="onChangeLanguage(item.code)"
                class="w-8 rounded-full border-2 border-gray-200 m-auto my-2 hover:scale-110 hover:cursor-pointer"
              />
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>


  <!-- <button
     @click="onChangeLanguage(item.code)"
     :class="[
       active || item.code == userStore.localeLanguage ? 'bg-gray-100 outline-none' : '',
       'block px-1 py-3 text-sm text-gray-700 w-full hover:scale-120',
     ]"
   >
     <img
       :src="item.imgUrl"
       :alt="item.code"
       @click="onChangeLanguage(item.code)"
       class="w-7 rounded-full border-2 border-gray-200 m-auto"
     />
   </button>-->
</template>

<style scoped></style>
